'use strict'

var hasDims = require('./has_dimensions.js')
var hasHighlight = require('./has_highlight.js')
var autoHighlight = require('./auto_highlight.js')


// var validOptions = function(options) {
//     return (
//         _.isObject(options)
//         && _.isNumber(options.width)
//         && _.isNumber(options.height)
//     )
// }

module.exports = function getImageHighlightPosition(image, options) {
    // validate image
    if (! hasDims(image)) throw new Error('Invalid image')

    var highlight
    if (hasHighlight(image)) {
        highlight = image.highlight
    } else {
        highlight = autoHighlight(image)
    }

    // calculate the center point of the highlight
    var highlight_center = {
        x: highlight.x + (highlight.w / 2),
        y: highlight.y + (highlight.h / 2),
    }

    // calculate position of the center as percentage of image dimensions
    var position = {
        left: (highlight_center.x / image.width) * 100,
        top: (highlight_center.y / image.height) * 100,
    }

    // round percentages to four decimal places
    Object.keys(position).forEach(function(key) {
        var value = position[key]
        value = Math.round(value * 10000) / 10000
        position[key] = value
    })

    return position
}

// var image_ratio = image.width / image.height
// var box_ratio = options.width / options.height


/*

var image_x = 0,
    image_y = 0,
    bg_size, bg_pos, r, top_pct, left_pct, offset_height, offset_width,
    // container dims from parent template view
    img_h = this.options.$dim_el.height(),
    img_w = this.options.$dim_el.width(),
    unit = 'px';

var image = (
    user.get('images').findWhere({ active: true })
    || new PlaceholderImage()
);

var container_ratio = img_w / img_h,
    image_ratio = image.get('width') / image.get('height');

if (container_ratio >= image_ratio) {
    r = img_w / image.get('width');

    offset_height = image.get('height') * r;
    offset_width = img_w;

    top_pct = (image.get('highlight.y') + (image.get('highlight.h') * 0.5));
    top_pct = top_pct / image.get('height');

    image_y = (top_pct * offset_height) - (img_h * 0.5);
    image_y =
        -Math.abs(
            Math.max(
                // top edge of image
                0,
                Math.min(
                    // top edge of user highlight
                    image_y,
                    // bottom edge of image
                    offset_height - img_h
                )
            )
        );
} else if (container_ratio < image_ratio) {
    r = img_h / image.get('height');

    offset_width = image.get('width') * r;
    offset_height = img_h;

    left_pct = (image.get('highlight.x') + (image.get('highlight.w')) * 0.5);
    left_pct = left_pct / image.get('width');

    image_x = (left_pct * offset_width) - (img_w * 0.5);
    image_x =
        -Math.abs(
            Math.max(
                // left edge of image
                0,
                Math.min(
                    // left edge of user highlight
                    image_x,
                    // right edge of image
                    offset_width - img_w
                )
            )
        );
}

bg_size = offset_width + unit + ' ' + offset_height + unit;
bg_pos = image_x + unit + ' ' + image_y + unit;

this.image_info.set({
    width: img_w + unit,
    height: img_h + unit,
    size: bg_size,
    position: bg_pos
});

*/
